export abstract class MapUtilsService {
    abstract roomNameToXY(room: string): [number, number];
}

export function MapUtilsServiceFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('MapUtils');
}

export const MapUtilsServiceProvider = {
    provide: MapUtilsService,
    useFactory: MapUtilsServiceFactory,
    deps: ['$injector']
};
